import React, { useState } from "react";

type Props = {
  data: any; // your JSON response
};

const DynamicJsonViewer: React.FC<Props> = ({ data }) => {
  // render recursively
  const renderValue = (value: any): React.ReactNode => {
    if (value === null || value === undefined) return <span className="text-gray-500">null</span>;

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        return (
          <ul className="ml-4">
            {value.map((item, idx) => (
              <li key={idx}>{renderValue(item)}</li>
            ))}
          </ul>
        );
      } else {
        // object
        return (
          <div className="ml-4 border-l border-gray-300 pl-3">
            {Object.entries(value || {}).map(([k, v]) => (
              <KeyValue key={k} k={k} v={v} />
            ))}
          </div>
        );
      }
    }

    // primitive
    return <span className="text-blue-700">{String(value)==="Test Incident Response"?"Automated Endpoint Threat Response":String(value)}</span>;
  };

  // A small subcomponent to handle collapsible sections
  const KeyValue: React.FC<{ k: string; v: any }> = ({ k, v }) => {
    const [open, setOpen] = useState(true);
    const isObject = typeof v === "object" && v !== null;

    return (
      <div className="mb-1">
        <div className="cursor-pointer select-none" onClick={() => isObject && setOpen(!open)}>
          <span className="font-semibold">{k}:</span>{" "}
          {!isObject && renderValue(v)}
          {isObject && (
            <span className="text-gray-500 text-sm ml-1">{open ? "▼" : "▶"}</span>
          )}
        </div>
        {isObject && open && <div>{renderValue(v)}</div>}
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow p-4 text-sm font-mono overflow-x-auto">
      {Object.entries(data || {}).map(([k, v]) => (
        <KeyValue key={k} k={k} v={v} />
      ))}
    </div>
  );
};

export default DynamicJsonViewer;
